/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react';
import { useGLTF, useAnimations } from '@react-three/drei';
import * as THREE from 'three';
import { useFrame } from '@react-three/fiber';

export default function Model({ explode }) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF('/models/planet.glb');
  const { actions } = useAnimations(animations, group);
  useFrame(() => {
    group.current.rotation.y += explode ? 0.001 : 0.004;
  });
  useEffect(() => {
    if (explode) {
      playForward();
    } else {
      playBackward();
    }
  }, [explode]);
  const playForward = () => {
    Object.keys(actions).map((key) => {
      //  console.log(actions[key]);
      actions[key].timeScale = 20;
      actions[key].paused = false;
      actions[key].clampWhenFinished = true;
      actions[key].setLoop(THREE.LoopOnce);
      actions[key].play();
    });
  };
  const playBackward = () => {
    Object.keys(actions).map((key) => {
      actions[key].paused = false;
      actions[key].setLoop(THREE.LoopOnce);
      actions[key].clampWhenFinished = true;
      actions[key].timeScale = -20;
      actions[key].play();
    });
  };

  return (
    <group ref={group} dispose={null}>
      <group name="Sphere_cell" position={[0.91, -0.07, 0.07]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell204.geometry}
          material={nodes.Sphere_cell204.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell204_1.geometry}
          material={nodes.Sphere_cell204_1.material}
        />
      </group>
      <group name="Sphere_cell001" position={[0.04, -0.72, 0.62]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell205.geometry}
          material={nodes.Sphere_cell205.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell205_1.geometry}
          material={nodes.Sphere_cell205_1.material}
        />
      </group>
      <group name="Sphere_cell003" position={[-0.56, -0.14, 0.8]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell117.geometry}
          material={nodes.Sphere_cell117.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell117_1.geometry}
          material={nodes.Sphere_cell117_1.material}
        />
      </group>
      <group name="Sphere_cell005" position={[0.2, -0.22, -0.91]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell118.geometry}
          material={nodes.Sphere_cell118.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell118_1.geometry}
          material={nodes.Sphere_cell118_1.material}
        />
      </group>
      <group name="Sphere_cell006" position={[-0.21, 0.1, -0.82]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell119.geometry}
          material={nodes.Sphere_cell119.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell119_1.geometry}
          material={nodes.Sphere_cell119_1.material}
        />
      </group>
      <group name="Sphere_cell008" position={[-0.67, 0.24, -0.06]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell120.geometry}
          material={nodes.Sphere_cell120.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell120_1.geometry}
          material={nodes.Sphere_cell120_1.material}
        />
      </group>
      <group name="Sphere_cell009" position={[0.59, 0.15, 0.17]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell121.geometry}
          material={nodes.Sphere_cell121.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell121_1.geometry}
          material={nodes.Sphere_cell121_1.material}
        />
      </group>
      <group name="Sphere_cell010" position={[-0.02, 0.99, 0.07]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell122.geometry}
          material={nodes.Sphere_cell122.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell122_1.geometry}
          material={nodes.Sphere_cell122_1.material}
        />
      </group>
      <group name="Sphere_cell012" position={[-0.67, 0.07, 0.56]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell123.geometry}
          material={nodes.Sphere_cell123.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell123_1.geometry}
          material={nodes.Sphere_cell123_1.material}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        name="Sphere_cell013"
        geometry={nodes.Sphere_cell013.geometry}
        material={nodes.Sphere_cell013.material}
        position={[-0.28, 0.12, 0.1]}
      />
      <group name="Sphere_cell014" position={[-0.07, 0.62, -0.74]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell125.geometry}
          material={nodes.Sphere_cell125.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell125_1.geometry}
          material={nodes.Sphere_cell125_1.material}
        />
      </group>
      <group name="Sphere_cell015" position={[-0.06, 0.88, 0.33]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell126.geometry}
          material={nodes.Sphere_cell126.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell126_1.geometry}
          material={nodes.Sphere_cell126_1.material}
        />
      </group>
      <group name="Sphere_cell016" position={[-0.06, -0.97, -0.02]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell127.geometry}
          material={nodes.Sphere_cell127.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell127_1.geometry}
          material={nodes.Sphere_cell127_1.material}
        />
      </group>
      <group name="Sphere_cell017" position={[0.44, -0.2, 0.8]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell128.geometry}
          material={nodes.Sphere_cell128.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell128_1.geometry}
          material={nodes.Sphere_cell128_1.material}
        />
      </group>
      <group name="Sphere_cell018" position={[0.1, 0.8, -0.57]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell129.geometry}
          material={nodes.Sphere_cell129.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell129_1.geometry}
          material={nodes.Sphere_cell129_1.material}
        />
      </group>
      <group name="Sphere_cell019" position={[-0.15, 0.68, 0.36]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell130.geometry}
          material={nodes.Sphere_cell130.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell130_1.geometry}
          material={nodes.Sphere_cell130_1.material}
        />
      </group>
      <group name="Sphere_cell020" position={[-0.56, -0.23, -0.6]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell131.geometry}
          material={nodes.Sphere_cell131.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell131_1.geometry}
          material={nodes.Sphere_cell131_1.material}
        />
      </group>
      <group name="Sphere_cell021" position={[0.62, 0.59, 0.22]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell132.geometry}
          material={nodes.Sphere_cell132.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell132_1.geometry}
          material={nodes.Sphere_cell132_1.material}
        />
      </group>
      <group name="Sphere_cell022" position={[0.06, -0.55, -0.7]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell133.geometry}
          material={nodes.Sphere_cell133.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell133_1.geometry}
          material={nodes.Sphere_cell133_1.material}
        />
      </group>
      <group name="Sphere_cell023" position={[0.27, -0.09, -0.87]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell134.geometry}
          material={nodes.Sphere_cell134.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell134_1.geometry}
          material={nodes.Sphere_cell134_1.material}
        />
      </group>
      <group name="Sphere_cell024" position={[-0.64, 0.57, -0.33]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell135.geometry}
          material={nodes.Sphere_cell135.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell135_1.geometry}
          material={nodes.Sphere_cell135_1.material}
        />
      </group>
      <group name="Sphere_cell025" position={[-0.67, -0.45, 0.26]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell136.geometry}
          material={nodes.Sphere_cell136.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell136_1.geometry}
          material={nodes.Sphere_cell136_1.material}
        />
      </group>
      <group name="Sphere_cell026" position={[-0.17, -0.72, 0.33]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell137.geometry}
          material={nodes.Sphere_cell137.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell137_1.geometry}
          material={nodes.Sphere_cell137_1.material}
        />
      </group>
      <group name="Sphere_cell027" position={[0.57, -0.55, -0.34]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell138.geometry}
          material={nodes.Sphere_cell138.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell138_1.geometry}
          material={nodes.Sphere_cell138_1.material}
        />
      </group>
      <group name="Sphere_cell028" position={[0.73, -0.33, -0.42]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell139.geometry}
          material={nodes.Sphere_cell139.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell139_1.geometry}
          material={nodes.Sphere_cell139_1.material}
        />
      </group>
      <group name="Sphere_cell029" position={[0.5, -0.76, 0.12]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell140.geometry}
          material={nodes.Sphere_cell140.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell140_1.geometry}
          material={nodes.Sphere_cell140_1.material}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        name="Sphere_cell030"
        geometry={nodes.Sphere_cell030.geometry}
        material={nodes.Sphere_cell030.material}
        position={[-0.03, 0.26, 0.43]}
      />
      <group name="Sphere_cell031" position={[0.44, -0.75, -0.38]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell142.geometry}
          material={nodes.Sphere_cell142.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell142_1.geometry}
          material={nodes.Sphere_cell142_1.material}
        />
      </group>
      <group name="Sphere_cell032" position={[0.74, -0.5, -0.35]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell143.geometry}
          material={nodes.Sphere_cell143.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell143_1.geometry}
          material={nodes.Sphere_cell143_1.material}
        />
      </group>
      <group name="Sphere_cell033" position={[-0.2, -0.26, 0.83]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell146.geometry}
          material={nodes.Sphere_cell146.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell146_1.geometry}
          material={nodes.Sphere_cell146_1.material}
        />
      </group>
      <group name="Sphere_cell035" position={[-0.16, -0.94, 0.18]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell147.geometry}
          material={nodes.Sphere_cell147.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell147_1.geometry}
          material={nodes.Sphere_cell147_1.material}
        />
      </group>
      <group name="Sphere_cell036" position={[-0.1, 0.4, -0.9]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell148.geometry}
          material={nodes.Sphere_cell148.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell148_1.geometry}
          material={nodes.Sphere_cell148_1.material}
        />
      </group>
      <group name="Sphere_cell037" position={[-0.83, -0.19, -0.47]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell149.geometry}
          material={nodes.Sphere_cell149.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell149_1.geometry}
          material={nodes.Sphere_cell149_1.material}
        />
      </group>
      <group name="Sphere_cell038" position={[0.18, -0.88, 0.28]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell150.geometry}
          material={nodes.Sphere_cell150.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell150_1.geometry}
          material={nodes.Sphere_cell150_1.material}
        />
      </group>
      <group name="Sphere_cell039" position={[0.27, 0.88, -0.11]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell151.geometry}
          material={nodes.Sphere_cell151.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell151_1.geometry}
          material={nodes.Sphere_cell151_1.material}
        />
      </group>
      <group name="Sphere_cell041" position={[0.6, 0.23, -0.73]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell152.geometry}
          material={nodes.Sphere_cell152.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell152_1.geometry}
          material={nodes.Sphere_cell152_1.material}
        />
      </group>
      <group name="Sphere_cell042" position={[0.78, -0.4, 0.09]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell153.geometry}
          material={nodes.Sphere_cell153.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell153_1.geometry}
          material={nodes.Sphere_cell153_1.material}
        />
      </group>
      <group name="Sphere_cell043" position={[-0.28, 0.66, -0.58]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell154.geometry}
          material={nodes.Sphere_cell154.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell154_1.geometry}
          material={nodes.Sphere_cell154_1.material}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        name="Sphere_cell044"
        geometry={nodes.Sphere_cell044.geometry}
        material={nodes.Sphere_cell044.material}
        position={[-0.01, -0.32, -0.35]}
      />
      <group name="Sphere_cell046" position={[-0.35, -0.83, -0.1]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell156.geometry}
          material={nodes.Sphere_cell156.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell156_1.geometry}
          material={nodes.Sphere_cell156_1.material}
        />
      </group>
      <group name="Sphere_cell047" position={[0.18, 0.33, 0.78]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell157.geometry}
          material={nodes.Sphere_cell157.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell157_1.geometry}
          material={nodes.Sphere_cell157_1.material}
        />
      </group>
      <group name="Sphere_cell048" position={[0.11, -0.88, -0.2]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell158.geometry}
          material={nodes.Sphere_cell158.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell158_1.geometry}
          material={nodes.Sphere_cell158_1.material}
        />
      </group>
      <group name="Sphere_cell049" position={[-0.75, -0.3, 0.5]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell159.geometry}
          material={nodes.Sphere_cell159.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell159_1.geometry}
          material={nodes.Sphere_cell159_1.material}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        name="Sphere_cell050"
        geometry={nodes.Sphere_cell050.geometry}
        material={nodes.Sphere_cell050.material}
        position={[0.38, -0.31, 0.4]}
      />
      <group name="Sphere_cell051" position={[-0.43, 0.37, 0.69]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell161.geometry}
          material={nodes.Sphere_cell161.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell161_1.geometry}
          material={nodes.Sphere_cell161_1.material}
        />
      </group>
      <group name="Sphere_cell052" position={[0.5, -0.13, -0.75]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell162.geometry}
          material={nodes.Sphere_cell162.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell162_1.geometry}
          material={nodes.Sphere_cell162_1.material}
        />
      </group>
      <group name="Sphere_cell053" position={[0.78, 0.05, -0.43]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell163.geometry}
          material={nodes.Sphere_cell163.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell163_1.geometry}
          material={nodes.Sphere_cell163_1.material}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        name="Sphere_cell055"
        geometry={nodes.Sphere_cell055.geometry}
        material={nodes.Sphere_cell055.material}
        position={[0.25, -0.22, 0.17]}
      />
      <group name="Sphere_cell060" position={[-0.4, 0.69, 0.58]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell165.geometry}
          material={nodes.Sphere_cell165.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell165_1.geometry}
          material={nodes.Sphere_cell165_1.material}
        />
      </group>
      <group name="Sphere_cell061" position={[0.26, 0.12, -0.91]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell166.geometry}
          material={nodes.Sphere_cell166.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell166_1.geometry}
          material={nodes.Sphere_cell166_1.material}
        />
      </group>
      <group name="Sphere_cell063" position={[0.71, -0.5, 0.41]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell167.geometry}
          material={nodes.Sphere_cell167.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell167_1.geometry}
          material={nodes.Sphere_cell167_1.material}
        />
      </group>
      <group name="Sphere_cell064" position={[0.92, 0.37, -0.07]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell168.geometry}
          material={nodes.Sphere_cell168.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell168_1.geometry}
          material={nodes.Sphere_cell168_1.material}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        name="Sphere_cell065"
        geometry={nodes.Sphere_cell065.geometry}
        material={nodes.Sphere_cell065.material}
        position={[0.33, -0.06, -0.35]}
      />
      <group name="Sphere_cell066" position={[-0.82, -0.44, 0.03]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell170.geometry}
          material={nodes.Sphere_cell170.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell170_1.geometry}
          material={nodes.Sphere_cell170_1.material}
        />
      </group>
      <group name="Sphere_cell067" position={[0.22, 0.47, -0.7]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell171.geometry}
          material={nodes.Sphere_cell171.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell171_1.geometry}
          material={nodes.Sphere_cell171_1.material}
        />
      </group>
      <group name="Sphere_cell068" position={[-0.13, 0.89, -0.19]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell172.geometry}
          material={nodes.Sphere_cell172.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell172_1.geometry}
          material={nodes.Sphere_cell172_1.material}
        />
      </group>
      <group name="Sphere_cell070" position={[-0.61, -0.56, -0.14]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell173.geometry}
          material={nodes.Sphere_cell173.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell173_1.geometry}
          material={nodes.Sphere_cell173_1.material}
        />
      </group>
      <group name="Sphere_cell071" position={[-0.75, 0.06, -0.43]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell174.geometry}
          material={nodes.Sphere_cell174.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell174_1.geometry}
          material={nodes.Sphere_cell174_1.material}
        />
      </group>
      <group name="Sphere_cell072" position={[-0.92, -0.01, 0.09]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell175.geometry}
          material={nodes.Sphere_cell175.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell175_1.geometry}
          material={nodes.Sphere_cell175_1.material}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        name="Sphere_cell073"
        geometry={nodes.Sphere_cell073.geometry}
        material={nodes.Sphere_cell073.material}
        position={[-0.02, 0.3, -0.21]}
      />
      <group name="Sphere_cell074" position={[-0.31, -0.4, 0.47]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell177.geometry}
          material={nodes.Sphere_cell177.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell177_1.geometry}
          material={nodes.Sphere_cell177_1.material}
        />
      </group>
      <group name="Sphere_cell076" position={[0.92, 0.1, -0.12]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell178.geometry}
          material={nodes.Sphere_cell178.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell178_1.geometry}
          material={nodes.Sphere_cell178_1.material}
        />
      </group>
      <group name="Sphere_cell077" position={[-0.4, -0.02, 0.88]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell179.geometry}
          material={nodes.Sphere_cell179.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell179_1.geometry}
          material={nodes.Sphere_cell179_1.material}
        />
      </group>
      <group name="Sphere_cell080" position={[-0.8, 0.4, 0.38]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell180.geometry}
          material={nodes.Sphere_cell180.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell180_1.geometry}
          material={nodes.Sphere_cell180_1.material}
        />
      </group>
      <group name="Sphere_cell081" position={[0.67, 0.41, -0.39]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell181.geometry}
          material={nodes.Sphere_cell181.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell181_1.geometry}
          material={nodes.Sphere_cell181_1.material}
        />
      </group>
      <group name="Sphere_cell082" position={[-0.36, -0.54, -0.62]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell182.geometry}
          material={nodes.Sphere_cell182.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell182_1.geometry}
          material={nodes.Sphere_cell182_1.material}
        />
      </group>
      <group name="Sphere_cell083" position={[-0.62, 0.65, 0.17]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell183.geometry}
          material={nodes.Sphere_cell183.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell183_1.geometry}
          material={nodes.Sphere_cell183_1.material}
        />
      </group>
      <group name="Sphere_cell084" position={[0.36, -0.52, 0.63]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell184.geometry}
          material={nodes.Sphere_cell184.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell184_1.geometry}
          material={nodes.Sphere_cell184_1.material}
        />
      </group>
      <group name="Sphere_cell085" position={[0.73, -0.05, 0.55]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell185.geometry}
          material={nodes.Sphere_cell185.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sphere_cell185_1.geometry}
          material={nodes.Sphere_cell185_1.material}
        />
      </group>
    </group>
  );
}

useGLTF.preload('/test3.glb');
